import {
  ExportField,
  ExportFilterGroups,
  ExportType,
  Frequency,
  ReportType,
  ScheduleFrequency
} from "PFApp/booking/types/export_booking";
import { Template } from "PFApp/booking/types/manage_reports";
import { Value } from "PFTypes";
import { useCallback, useState } from "react";

import { TabType } from "./export_wizard_content";

export interface ExportWizardData {
  currentTab: TabType;
  reportType: ReportType;
  exportType: ExportType;
  selectedFields: ExportField[];
  selectedFilters: ExportFilterGroups<Value>;
  frequency: Frequency;
  schedule: {
    frequency: ScheduleFrequency;
    value: string | null;
  };
  modals: {
    reportNameOpen?: boolean;
    scheduleSettingsOpen?: boolean;
  };
  selectedTemplate?: Template;
  templateId?: number;
}

interface ModalDataStateType {
  isOpen: boolean;
  data: ExportWizardData;
}

export type ExportWizardModalType = {
  open: (data?: Partial<ExportWizardData>) => void;
  close: () => void;
  state: ModalDataStateType;
  updateData: (value: Partial<ModalDataStateType["data"]>) => void;
};

export const INITIAL_DATA: ModalDataStateType["data"] = {
  currentTab: "templateAndReportType",
  reportType: ReportType.Overall,
  exportType: ExportType.Template,
  selectedFields: [],
  selectedFilters: {},
  frequency: Frequency.Daily,
  schedule: {
    frequency: ScheduleFrequency.No,
    value: null
  },
  modals: {
    reportNameOpen: false,
    scheduleSettingsOpen: false
  }
};

export const useExportWizardModal = (): ExportWizardModalType => {
  const [modalState, setModalState] = useState<ModalDataStateType>({ isOpen: false, data: INITIAL_DATA });

  const open = useCallback(
    (data: Partial<ExportWizardData> = {}) =>
      setModalState({ isOpen: true, data: { ...INITIAL_DATA, ...data } }),
    []
  );

  const close = useCallback(() => setModalState({ isOpen: false, data: INITIAL_DATA }), []);

  const updateModalStateData = useCallback(
    (value: Partial<ModalDataStateType["data"]>) =>
      setModalState((prev) => ({ ...prev, data: { ...(prev.data || {}), ...value } })),
    []
  );

  return { open, close, state: modalState, updateData: updateModalStateData };
};
